import Vue from 'vue'
import { ENV_KEY } from '@/constants/env'

Vue.mixin({
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    liffIdExists() {
      return this.$store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID)
    },
  },
  methods: {
    handleError(err) {
      const data = err.response?.data

      if (data) {
        this.$alert({
          message: data.meta.message,
          dangerouslyUseHTMLString: true,
          type: 'error',
          duration: this.Constants.TOAST_MESSAGE_DURATION,
        })
        return
      }

      this.$message.error({
        dangerouslyUseHTMLString: true,
        message: err.message,
        duration: this.Constants.TOAST_MESSAGE_DURATION,
      })
    },
  },
})
